import React from 'react'
import { graphql, Link } from 'gatsby'
import Page from 'src/templates/Page'
import Card from 'src/components/Card'

const Guides = ({
  location,
  data: {
    allMdx: { edges },
  },
}) => (
  <Page location={location}>
    <h1>Guides</h1>
    {edges.map((guide) => (
      <Link key={guide.node.frontmatter.path} to={guide.node.frontmatter.path}>
        <Card frontmatter={guide.node.frontmatter} />
      </Link>
    ))}
  </Page>
)
export default Guides

export const query = graphql`
  query {
    allMdx(
      filter: { fileAbsolutePath: { regex: "pages/guides/" } }
      sort: {order: DESC, fields: frontmatter___date}
    ) {
      edges {
        node {
          frontmatter {
            title
            description
            thumbnail {
              childImageSharp {
                gatsbyImageData(placeholder: NONE, height: 256, width: 256)
              }
            }
            path
          }
        }
      }
    }
  }
`
